import { FileText } from 'lucide-react';

type CVListEmptySearchProps = {
  title: string;
  description: string;
};

export default function CVListEmptySearch({ title, description }: CVListEmptySearchProps) {
  return (
    <div className="text-center py-16">
      <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
        <FileText className="w-8 h-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium text-foreground mb-2">{title}</h3>
      <p className="text-muted-foreground">{description}</p>
    </div>
  );
}
